import React, { useState, useEffect } from 'react'
import classes from './LoginPage2.module.css'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { loginApi } from '../../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../../store/slices/userSlice'
import { toast } from 'react-toastify'
import SmallLoader from '../../component/SmallLoader'

const LoginPage2 = () => {

    const [msisdn, setMsisdn] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const dispatch = useDispatch();

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    useEffect(() => {
        if (userDetails?.token) {
            navigate("/home");
        }
    }, [userDetails]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault();
            if (msisdn?.trim().length == 0) return;
            setLoginLoading(true);
            const response = await loginApi(msisdn);
            console.log(response, 'response');
            dispatch(setUserDetails(response?.data));
            setLoginLoading(false);
            toast.success("Login Successfully!");
            navigate("/home");
        } catch (error) {
            setLoginLoading(false);
            console.log(error, 'error');
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }

    return (
        <div className={classes.page}>

            {/* ══ LEFT — Brand Hero ══ */}
            <div className={classes.leftPanel}>
                <div className={classes.arcCircle} />

                {/* Logo */}
                <div className={classes.logo}>

                    <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
                    {/* <span className={classes.logoIcon}>⚽</span>
                    <span className={classes.logoWordmark}>
                        <em>Football</em> Masters
                    </span> */}
                </div>

                {/* Hero copy */}
                <p className={classes.heroEyebrow}>Welcome Back</p>
                <h1 className={classes.heroTitle}>
                    Back In
                    <span className={classes.accent}>The Game.</span>
                </h1>
                <p className={classes.heroSub}>
                    Log back in to check your squad, track live scores,
                    and stay on top of the leaderboard.
                </p>

                {/* Feature pills */}
                <div className={classes.pillsRow}>
                    <span className={classes.pill}>🏅 Live Scores</span>
                    <span className={classes.pill}>📊 Leaderboard</span>
                    <span className={classes.pill}>🎯 Predictions</span>
                </div>

                {/* Stats */}
                {/* <div className={classes.statsRow}>
                    <div className={classes.stat}>
                        <span className={classes.statNum}>2M+</span>
                        <span className={classes.statLabel}>Players</span>
                    </div>
                    <div className={classes.statDivider} />
                    <div className={classes.stat}>
                        <span className={classes.statNum}>₹50L</span>
                        <span className={classes.statLabel}>Prizes Won</span>
                    </div>
                    <div className={classes.statDivider} />
                    <div className={classes.stat}>
                        <span className={classes.statNum}>500+</span>
                        <span className={classes.statLabel}>Matches</span>
                    </div>
                </div> */}
            </div>

            {/* ══ RIGHT — Form ══ */}
            <div className={classes.rightPanel}>
                <div className={classes.formContainer}>

                    <h2 className={classes.formTitle}>
                        Welcome <span>Back</span>
                    </h2>
                    <p className={classes.formSubtitle}>
                        Enter your number to continue to your squad.
                    </p>

                    {/* Tab toggle */}
                    <div className={classes.tabToggle}>
                        <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
                            Login
                        </button>
                        <button
                            type="button"
                            className={classes.tab}
                            onClick={() => navigate(`/?ext_ref=${extRef}`)}
                        >
                            Subscribe
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmission}>

                        {/* Phone */}
                        <p className={classes.sectionLabel}>Mobile Number</p>
                        <div className={classes.phoneRow}>
                            <div className={classes.countryPill}>
                                <img src="/assets/images/gabon.png" alt="India" className={classes.flag} />
                                <span className={classes.dialCode}>+241</span>
                            </div>
                            <input
                                id="msisdn"
                                name="msisdn"
                                type="number"
                                autoFocus
                                onWheel={(e) => e.target.blur()}
                                placeholder="Enter phone number"
                                className={classes.phoneInput}
                                onChange={(e) => setMsisdn(e.target.value)}
                                value={msisdn}
                            />
                        </div>

                        {/* Terms */}
                        <div className={classes.termsRow}>
                            <input
                                type="checkbox"
                                id="terms"
                                name="Terms & Conditions"
                                value="Terms"
                                className={classes.termsCheck}
                                checked
                                readOnly
                            />
                            <label htmlFor="terms" className={classes.termsText}>
                                By logging in, you agree to our{" "}
                                <span className={classes.termsLink}>Terms & Conditions</span>
                            </label>
                        </div>

                        {/* CTA */}
                        <button type="submit" disabled={loginLoading} className={classes.ctaBtn}>
                            {loginLoading
                                ? <SmallLoader style={{ border: "4px solid #0f0e0d" }} />
                                : <>⚡ Login Now</>
                            }
                        </button>

                    </form>

                    {/* No account nudge */}
                    <p className={classes.switchPrompt}>
                        New here?{" "}
                        <span
                            className={classes.switchLink}
                            onClick={() => navigate(`/?ext_ref=${extRef}`)}
                        >
                            Subscribe and join the league →
                        </span>
                    </p>

                    {/* ── Copyright footer ── */}
                    <div className={classes.copyrightFooter}>
                        <div className={classes.copyrightDivider} />
                        <div className={classes.copyrightInner}>
                            <span className={classes.copyrightBadge}>
                                <span className={classes.copyrightBadgeIcon}>⚽</span>
                                Football Masters
                            </span>
                            <p className={classes.copyrightText}>
                                © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                            </p>
                            <p className={classes.copyrightSub}>All rights reserved</p>
                        </div>
                    </div>


                    {/* Trust strip */}
                    {/* <div className={classes.trustStrip}>
                        <span className={classes.trustItem}>🔒 Secure Login</span>
                        <span className={classes.trustDot} />
                        <span className={classes.trustItem}>✓ No Password</span>
                        <span className={classes.trustDot} />
                        <span className={classes.trustItem}>💬 24/7 Support</span>
                    </div> */}

                </div>
            </div>

        </div>
    )
}

export default LoginPage2